import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import './ActivityButtonGroup.scss';

const TYPES = ['call', 'email', 'meeting'];

function ActivityTypeSelectionModal({ open, toggle, onSelectType }) {
    const [t] = useTranslation('ACTIVITIES');

    const handleTypeSelection = (type) => {
        onSelectType(type);
        toggle();
    };

    return (
        <Modal isOpen={open} fade={false} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {t('COMMON:SELECT_ACTIVITY_TYPE')}
            </ModalHeader>
            <ModalBody>
                <div className="cont-btn-log">
                    <div className="row">
                        <div className="col-4">
                            <Button
                                className="btn-call activity-type-btn"
                                onClick={() => handleTypeSelection(TYPES[0])}
                            >
                                <span className="activity-type-text">{t('COMMON:CALL_LOG')}</span>
                            </Button>
                        </div>
                        <div className="col-4">
                            <Button className="btn-email activity-type-btn" onClick={() => handleTypeSelection(TYPES[1])}>
                                <span className="activity-type-text">{t('COMMON:EMAIL_LOG')}</span>
                            </Button>
                        </div>
                        <div className="col-4">
                            <Button
                                className="btn-meeting activity-type-btn"
                                onClick={() => handleTypeSelection(TYPES[2])}
                            >
                                <span className="activity-type-text">{t('COMMON:MEETING_LOG')}</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
}

export default ActivityTypeSelectionModal;
